module.exports = __webpack_public_path__ + "static/media/logo-white.7ca81582.png";